module.exports = __webpack_public_path__ + "img/sec9mob.989a371d.png";